import { ContentPanel } from "../components/home/content-panel";
import { Hero } from "../layouts/hero";
import { MainLayout } from "../layouts/mainLayout";

function Main() {
  return (
    <MainLayout>
      <div className="main">
        <Hero
          title={"Internal Team Tools & Operations"}
          desc={
            <>
              Create professional branded assets, store and manage files with
              the uploader, and find other internal tools as they're added.
            </>
          }
          eyebrow="Internal hub"
          height={"h-[33rem]"}
          centered
          // logoWidth={"w-10/12"}
        />
        <ContentPanel />
      </div>
    </MainLayout>
  );
}

export default Main;
